import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { CompanyDto } from '../../../../portal/search-api/models/company-dto';
import { CompanyFacetDto } from '../../../../portal/search-api/models/company-facet-dto';
import { SortDto } from '../../../../portal/search-api/models/sort-dto';
import { SavedSearchService } from '../../../../portal/search-api/services/saved-search.service';
import { select, Store } from '@ngrx/store';
import { selectSearchState } from '../../../../storage/contact-search/search.selectors';
import { IStore } from '../../../../storage/store';
import { faRedoAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { uniqBy as _uniqBy } from 'lodash';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { SaveSearchComponent } from '../dialog/save-search/save-search.component';
import {MeetingDialogComponent} from "../meeting-dialog/meeting-dialog.component";
import {MatCheckboxChange} from "@angular/material/checkbox";

type FilterItem = {
  checked: boolean;
  disabled: boolean;
  caption: string;
};

type SearchFilter = {
  items: FilterItem[];
  collapsed: boolean;
};

type CompanySearchFilters = Record<keyof CompanyFacetDto, SearchFilter>;

type SearchOptions = {
  showInactiveCompanies: boolean;
  hideMyOwnedCompanies: boolean;
  showOnlyDirectDials: boolean;
};

type SearchPager = {
  pageSize: number;
  pageNumber: number;
  totalElements: number;
  totalPages: number;
};

type AppliedFilterField<T> = Partial<Record<keyof T, FilterItem[]>>;
type AppliedFilter<T> = AppliedFilterField<T> & { filterName: keyof T };

type CompanyAppliedFilter = AppliedFilter<CompanyFacetDto>;

@Component({
  selector: 'company-search-content',
  templateUrl: './company-search-content.component.html',
  styleUrls: ['./company-search-content.component.scss'],
})
export class CompanySearchContentComponent implements OnChanges, OnInit {
  faRedoAlt = faRedoAlt;
  faSearch = faSearch;
  @Input() dataSource: CompanyDto[];
  @Input() loading: boolean;
  @Input() updatingFilters: boolean;
  @Input() searchTerm: string;

  innerSearchOptions: SearchOptions;
  @Input() searchOptions: SearchOptions;
  @Output() searchOptionsChanged = new EventEmitter<SearchOptions>();

  @Input() filters: CompanySearchFilters;
  @Output() filterChanged = new EventEmitter<CompanyAppliedFilter>();
  @Output() filterToggled = new EventEmitter<keyof CompanySearchFilters>();

  @Input() sorting: SortDto;
  @Output() sortingChanged = new EventEmitter<{ sortField: string }>();

  @Input() pager: SearchPager;
  @Output() pagerChanged = new EventEmitter<{
    pageNumber: number;
    pageSize: number;
  }>();
  @Output() clearAll = new EventEmitter();
  @Output() saveSearch = new EventEmitter();

  searchState$ = this.store.pipe(select(selectSearchState));
  filterValue:any = [];
  _searchOptions: SearchOptions;
  selectedCompanies:CompanyDto[]=[];

  constructor(
    private savedSearchService: SavedSearchService,
    private store: Store<IStore>, public dialog: MatDialog,
    public surveyDialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log("Company search content: ", this.filters)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('searchOptions' in changes) {
      const searchOptions: SearchOptions = changes.searchOptions.currentValue;
      this.innerSearchOptions = { ...searchOptions };
    }
  }

  public setSearchOptions(searchOptions: SearchOptions) {
    this._searchOptions = searchOptions
    this.searchOptionsChanged.emit(searchOptions);
  }

  public turnPage(pageNumber: number, pageSize: number) {
    this.pagerChanged.emit({ pageNumber, pageSize });
  }

  public sort(sortField: string) {
    this.sortingChanged.emit({ sortField });
  }

  public filter(filters: CompanyAppliedFilter) {

    let objIndex = this.filterValue.findIndex((obj => obj.filterName == filters.filterName));

    if(objIndex != -1){
      this.filterValue[objIndex] = filters
    }
    else
      this.filterValue = [{...filters},...this.filterValue]
    this.filterChanged.emit(filters);
  }

  public getSortClass(field: string): string {
    return this.sorting.field == field
      ? this.sorting.asc
        ? 'fas fa-caret-up'
        : 'fas fa-caret-down'
      : null;
  }

  openDialog() {
    const dialogRef = this.dialog.open(SaveSearchComponent, {width: '500px'});

    dialogRef.afterClosed().subscribe(name => {
      if(name){
        ['industry','employeeRange','ownership','revenueRange','location', 'companyName','country'].forEach((type)=>{
          let objIndex = this.filterValue.findIndex((obj => obj.filterName == type));
          let temp={};
          temp[type]=this.filters[type].items.filter((res)=> {return res.checked ==true});
          temp["filterName"] = type;
          if(temp[type].length)
          {
            if(objIndex != -1)
              this.filterValue[objIndex] = temp
            else
              this.filterValue = [{...temp},...this.filterValue];
          }
        })
        this.saveSearch.emit({...this.filterValue,...this.searchOptions, name});
      }
    });
  }

  openMeetingDialog() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "800px";
    dialogConfig.data ={
      meetingType:'company',
      companyId:this.selectedCompanies[0].id,
      companyName:this.selectedCompanies[0].companyName
    }

    const dialogRef = this.surveyDialog.open(
      MeetingDialogComponent, dialogConfig

    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {

      }
    });
  }
  selectCompany(event:MatCheckboxChange,company:CompanyDto){
    if(event.checked){
      this.selectedCompanies.push(company);
    }else{
      this.selectedCompanies = this.selectedCompanies.filter(item=>item !== company);
    }
  }
}
